import { FC } from 'react';
import { Icon, IconName } from 'Components/UI';
import Tooltip from 'Components/UI/Tooltip';
import { GetAvatar, ThumbType } from 'Utils/generateThumbnail';
import { Wrapper } from './styles';

interface IPermissaoUsuarioItem {
  username: string;
  userAvatar?: string;
  userAvatarThumb?: string;
  userAvatarThumbType?: ThumbType;
  privileges: number[];
  hasPlottingPermission?: boolean;
  index: number;
  onChange: (values: any) => void;
}

const buttonsPermission = ['Visualizar', 'Download', 'Upload', 'Editar'];

const PermissaoUsuarioItem: FC<IPermissaoUsuarioItem> = ({
  username,
  userAvatar,
  userAvatarThumb,
  userAvatarThumbType,
  privileges,
  hasPlottingPermission,
  index,
  onChange,
}) => {
  const changeHasPlottingPermission = () => {
    onChange({
      privileges,
      index,
      hasPlottingPermission: !hasPlottingPermission
    });
  };

  const changePermissionLevel = (level: number) => {
    if (level !== 0) {
      const permissionIndex = privileges.indexOf(level);
      permissionIndex >= 0
        ? privileges.splice(permissionIndex, 1)
        : privileges.push(level);
      onChange({
        index,
        hasPlottingPermission,
        privileges
      });
    }
  };

  return (
    <Wrapper>
      <div className="container containerUsername">
        <GetAvatar
          name={username}
          shape="circle"
          src={userAvatar}
          thumbSrc={userAvatarThumb}
          thumbType={userAvatarThumbType}
        />
        <span className="username">{username}</span>
      </div>

      {buttonsPermission.map((name, i) => (
        <Tooltip title={name} key={`buttonPermission-${i}`}>
          <div
            className="container containerButton"
            onClick={() => changePermissionLevel(i)}
          >
            <Icon
              icon={name.toLocaleLowerCase() as IconName}
              customSize={20}
              color={privileges.includes(i) ? 'primary' : 'cinzaPadrao'}
            />
            <p className={privileges.includes(i) ? 'selected' : ''}>
              {name.toLocaleUpperCase()}
            </p>
          </div>
        </Tooltip>
      ))}
      <Tooltip title="Plotagem">
        <div
          className="container containerButton"
          onClick={changeHasPlottingPermission}
        >
          <Icon
            icon="menuPlotagem"
            customSize={20}
            color={hasPlottingPermission ? 'primary' : 'cinzaPadrao'}
          />
          <p className={hasPlottingPermission ? 'selected' : ''}>PLOTAGEM</p>
        </div>
      </Tooltip>
    </Wrapper>
  );
};

export default PermissaoUsuarioItem;
